// routes/NewsRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import NewsletterPage from '../components/Frontend/NewsLetter/pages/NewsletterPage';

export const newsRoutes = (
    <Route path="/news" element={<MainLayout />}>
        <Route index element={<NewsletterPage />} />
    </Route>
);
